import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./ForgetPass.css";

const ForgotPass = () => {
  const navigate = useNavigate();

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const [step, setStep] = useState(1); // 1=email, 2=otp
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  /* ============================
     STEP 1 → SEND OTP
  ============================ */
  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.warn("⚠️ Email is required");
      return;
    }

    if (!API_BASE) {
      toast.error("API Base URL missing (.env issue)");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}forgot_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({ email }),
      });

      const data = await response.json();
      console.log("Forgot Password:", data);

      if (data.api_success || data.success) {
        toast.success(data.message || "OTP sent successfully");
        setStep(2);
      } else {
        toast.error(data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  /* ============================
     STEP 2 → VERIFY OTP & RESET
  ============================ */
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (!otp || !newPassword || !confirmPassword) {
      toast.warn("⚠️ All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("❌ Passwords do not match");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}verify_otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams({
          email,
          otp,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      const data = await response.json();
      console.log("Verify OTP:", data);

      if (data.api_success || data.success) {
        toast.success(data.message || "Password reset successful");

        setTimeout(() => {
          navigate("/login");
        }, 2000);
      } else {
        toast.error(data.message || "OTP verification failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        {step === 1 && (
          <>
            <h2>Forgot Password</h2>
            <p>Enter your registered email</p>

            <form onSubmit={handleSendOtp}>
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />

              <button type="submit" disabled={loading}>
                {loading ? "Sending OTP..." : "Send OTP"}
              </button>
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <h2>Reset Password</h2>
            <p>
              OTP sent to <b>{email}</b>
            </p>

            <form onSubmit={handleVerifyOtp}>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />

              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />

              <button type="submit" disabled={loading}>
                {loading ? "Verifying..." : "Reset Password"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPass;
